"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnMouseMove = void 0;
const Pointer_1 = __importDefault(require("ol/interaction/Pointer"));
const proj_1 = require("ol/proj");
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function useOnMouseMove(onMouseMove, calculateHoveredFeatures = false) {
    const onMouseMoveRef = react_1.useRef(onMouseMove);
    const map = useOLMap_1.useOLMap();
    react_1.useEffect(() => {
        onMouseMoveRef.current = onMouseMove;
    }, [onMouseMove]);
    react_1.useEffect(() => {
        const interaction = new Pointer_1.default({
            stopDown: false,
            handleMoveEvent: (e) => {
                var _a;
                if (((_a = e === null || e === void 0 ? void 0 : e.pointerEvent) === null || _a === void 0 ? void 0 : _a.pointerType) === 'touch') {
                    return;
                }
                onMouseMoveRef.current(proj_1.toLonLat(e.coordinate), e.pixel, calculateHoveredFeatures ? hoveredFeatures(map, e.pixel) : null);
            },
        });
        map.addInteraction(interaction);
        return () => {
            map.removeInteraction(interaction);
        };
    }, [map, calculateHoveredFeatures]);
}
exports.useOnMouseMove = useOnMouseMove;
const hoveredFeatures = (map, pixel) => {
    const ids = [];
    map.forEachFeatureAtPixel(pixel, (feature) => {
        ids.push(feature.getProperties().original || {
            id: feature.getId(),
            properties: { type: feature.getProperties().type },
        });
    });
    return ids;
};
//# sourceMappingURL=useOnMouseMove.js.map